/**
 *
 * Staff
 *
 */
import { SetupLoader } from 'core/components/SetupComponents/SetupLoader';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import { useOutsideAlerter } from 'core/hooks/useOutsideClickDetect';
import {
  BranchRole,
  City,
  Class,
  Country,
  Language,
} from 'core/utils/types/modules/org';
import { useFetchBranchRole } from 'features/BranchSetup/hooks/useFetchBranchRole';
import { useFetchCity } from 'features/BranchSetup/hooks/useFetchCity';
import { useFetchClassList } from 'features/BranchSetup/hooks/useFetchClass';
import { useFetchCountryCode } from 'features/BranchSetup/hooks/useFetchCountryCode';
import { useFetchLanguageList } from 'features/BranchSetup/hooks/useFetchLanguageList';

import React, { memo, useRef, useState } from 'react';
import { RootState } from 'controller/types';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';
import { useUserSetupSlice } from 'features/UserSetup/slice';
import { Field, Form, Formik, FormikProps } from 'formik';
import { GENDERS, getImageUrl, RoleColors, checkSuperAdmin } from 'core/utils/constants';

import { DropDown } from 'libs/DropDown';
import { Input } from 'core/components/Input';
import { TextArea } from 'core/components/TextArea';
import * as Yup from 'yup';
import {
  getCurrentDate
} from 'core/utils/constants/DateTime';
import { Button } from 'core/components/Button';
import { PhotoUrl } from 'core/components/SetupComponents/PhotoUrl';

import { PhotoNameCell } from 'core/components/SetupComponents/PhotoNameCell';
import { getName } from 'core/utils/setup';
import { Tag } from 'core/components/Tag';
import { error } from 'core/components/Notify';
import { SelectModal } from 'core/components/SetupComponents/SelectModal';
import staffSchema from './validationSchema';
import { MobileComponent } from 'core/components/SetupComponents/MobileComponent';
import DateTimePicker from 'core/components/DateTimePicker';
import dt from 'date-and-time';
import { replaceNullOrEmptyWithUndefined } from 'core/utils/constants';

interface Props {
  action?: string;
  values?: any;
  onNext?: () => void;
  customURL?: any;
}




export const Staff = memo((props: Props) => {
  const authData = useAuth();
  const dispatch = useDispatch();
  const { actions } = useUserSetupSlice();
  const state: any = useSelector((state: RootState) => state.userSetup);

  const params: any = useParams();
  const [cityList, setcityList] = React.useState<City[]>();
  const [countryList, setcountryList] = React.useState<Country[]>();
  const [classList, setclassList] = React.useState<Class[]>();
  const [branchRoleList, setbranchRoleList] = React.useState<BranchRole[]>();
  const [languageList, setlanguageList] = React.useState<Language[]>();
  const [selectedFile, setSelectedFile] = useState<File[]>();

  const [showModal, setshowModal] = React.useState<boolean>(false);
  const [showModalClassStaff, setshowModalClassStaff] = React.useState<boolean>(false);
  const [modalPayload, setmodalPayload] = React.useState<any>();
  const [initialValues, setinitialValues] = React.useState<any>();

  useFetchCountryCode(countryList, setcountryList);
  useFetchCity(cityList, setcityList);
  useFetchClassList(classList, setclassList);
  useFetchBranchRole(branchRoleList, setbranchRoleList);
  useFetchLanguageList(languageList, setlanguageList);

  const [startDate, setstartDate] = React.useState<any>(new Date());
  const [endDate, setendDate] = React.useState<any>(new Date());
  const [hideCalendarStart, sethideCalendarStart] =
    React.useState<boolean>(true);
  const [hideCalendarEnd, sethideCalendarEnd] = React.useState<boolean>(true);

  const refCalendarStart = useRef<HTMLDivElement>(null);
  const refCalendarStartMenu = useRef<HTMLDivElement>(null);
  useOutsideAlerter(refCalendarStart, refCalendarStartMenu, () =>
    sethideCalendarStart(true),
  );

  const refCalendarEnd = useRef<HTMLDivElement>(null);
  const refCalendarEndMenu = useRef<HTMLDivElement>(null);
  useOutsideAlerter(refCalendarEnd, refCalendarEndMenu, () =>
    sethideCalendarEnd(true),
  );

  const [enableEdit, setEnableEdit] = React.useState({
    MOBILE_NUMBER: false,
    EMAIL_ID: false,
    AADHAR_NUMBER: false,
  });

  const renderToggleLabel = (labelText: React.ReactNode, fieldKey: keyof typeof enableEdit) => {
    return (
      <span className="flex justify-between items-center w-full">
        <span className="flex items-center">{labelText}</span>
        {props.action === 'update' && (
          <span className="flex items-center gap-1 text-[11px] font-medium text-primary-main cursor-pointer pointer-events-auto">
            <input
              type="checkbox"
              className="cursor-pointer w-3 h-3 m-0"
              checked={enableEdit[fieldKey]}
              onChange={(e) =>
                setEnableEdit((prev) => ({ ...prev, [fieldKey]: e.target.checked }))
              }
            />
            <span className="mt-[1px]">Enable Edit</span>
          </span>
        )}
      </span>
    );
  };
  
  
  React.useEffect(() => {
    if (props.action === 'update') {

    } else {
      setinitialValues({
        FIRST_NAME: '',
        LAST_NAME: '',
        MIDDLE_NAME: '',
        STAFF_CODE: '',
        GENDER: '',
        LANGUAGE_ID: 0,
        PHOTO_URL: '',
        QUALIFICATION: '',
        TEACHING_SINCE: 0,
        COUNTRY_CODE: '+91',
        MOBILE_NUMBER: '',
        CONFIRM_COUNTRY_CODE: "+91",
        CONFIRM_MOBILE_NUMBER: "",
        ADDRESS: '',
        CITY_ID: 0,
        PINCODE: '',
        EMAIL_ID: undefined,
        AADHAR_NUMBER: '',
        BIRTH_DATE: getCurrentDate(new Date(), true),
        JOINING_DATE: getCurrentDate(new Date(), true),
        CLASS_TEACHER: [] as { CLASS_ID: number }[],
        STAFF_ROLES: [] as { BRANCH_ROLE_ID: number }[],
      });
    }
  }, [
    actions,
    authData?.SELECTED_ACADEMIC_YEAR.ACADEMIC_YEAR_ID,
    dispatch,
    props.action,
  ]);


  React.useEffect(() => {
    if (state?.navigate) {
      props?.onNext && props?.onNext();
      dispatch(actions.setNavigate(false));
    }
  }, [state?.navigate]);

  React.useEffect(() => {
    if (props?.values) {
      setinitialValues({
        ...props?.values,
        CLASS_TEACHER: [],
        STAFF_ROLES: [],
        CONFIRM_COUNTRY_CODE: "+91",
        CONFIRM_MOBILE_NUMBER: "",
      });
      setstartDate(new Date(props?.values?.JOINING_DATE));
      setendDate(new Date(props?.values?.BIRTH_DATE));
    }
  }, [props?.values]);

  return classList &&
    branchRoleList &&
    cityList &&
    countryList &&
    languageList &&
    initialValues ? (
    <Div>
      <SelectModal
        showModal={showModal}
        heading={'Delete Staff Role'}
        subHeading={'Are you sure you want to delete this Role?'}
        actionToDispatch={actions.deleteUserSetupStart}
        setshowModal={setshowModal}
        payload={{
          ...modalPayload,
          URL: 'staffRole',
        }}
        setPayload={setmodalPayload}
      />
      <SelectModal
        showModal={showModalClassStaff}
        heading={'Delete Class'}
        subHeading={'Are you sure you want to delete this Class?'}
        actionToDispatch={actions.deleteUserSetupStart}
        setshowModal={setshowModalClassStaff}
        payload={{
          ...modalPayload,
          URL: 'staffClassLink',
        }}
        setPayload={setmodalPayload}
      />
      <Formik
        validationSchema={staffSchema(props.action, enableEdit)}
        initialValues={initialValues}
        onSubmit={async values => {
          if (startDate && endDate && startDate < endDate) {
            error('Joining Date should greater than Birth date!', true);
          } else {

            const payloadTobeSent = {
              ...values,
              CLASS_TEACHER: values.CLASS_TEACHER.map(item => {
                return { CLASS_ID: item.CLASS_ID };
              }),
              INSTITUTE_ID: authData?.INSTITUTE_ID as number,
              STAFF_ROLES: values.STAFF_ROLES.map(item => {
                return {
                  // USER_ID: props?.values?.USER_ID,
                  BRANCH_ROLE_ID: item.BRANCH_ROLE_ID,
                };
              }),
              
              CONFIRM_COUNTRY_CODE: undefined,
              CONFIRM_MOBILE_NUMBER: undefined,
            }

            if (props.action === 'update') {
              if (!enableEdit.AADHAR_NUMBER) delete payloadTobeSent.AADHAR_NUMBER;
              if (!enableEdit.EMAIL_ID) delete payloadTobeSent.EMAIL_ID;
              if (!enableEdit.MOBILE_NUMBER) {
                delete payloadTobeSent.MOBILE_NUMBER;
                // Notice we DO NOT delete COUNTRY_CODE to prevent API 422 error
              }
            }

            replaceNullOrEmptyWithUndefined(payloadTobeSent)

            dispatch(
              actions.createUserSetupStart({
                data: !props.action
                  ? [
                    {
                      ...values,
                      BRANCH_ID: authData?.BRANCH_ID as number,
                      INSTITUTE_ID: authData?.INSTITUTE_ID as number,
                      CLASS_TEACHER: values.CLASS_TEACHER.map(item => {
                        return { CLASS_ID: item.CLASS_ID };
                      }),
                      STAFF_ROLES: values.STAFF_ROLES.map(item => {
                        return { BRANCH_ROLE_ID: item.BRANCH_ROLE_ID };
                      }),
                      STAFF_ID:
                        props.action === 'update'
                          ? (props?.values?.STAFF_ID as number)
                          : undefined,
                      
                      CONFIRM_COUNTRY_CODE: undefined,
                      CONFIRM_MOBILE_NUMBER: undefined,
                    },
                  ]
                  : [
                    {
                      ...payloadTobeSent
                    },
                  ],
                action: props.action || 'save',
                URL: (props?.customURL || params?.url || 'staff'),
                message: props?.action
                  ? 'Updated Successfully!'
                  : 'Created Successfully!',
              }),
            );


          }
        }}
      >
        {(formikProps: FormikProps<any>) => (
          <Form>
            <div className="flex justify-between items-center">
              <div className="flex justify-center items-center w-[35%]">
                <Field name="PHOTO_URL">
                  {({ field, form, meta }) => (
                    <PhotoUrl
                      uploadToS3={!props.action ? true : false}
                      size="w-60 h-60"
                      selectedFile={selectedFile}
                      setSelectedFile={setSelectedFile}
                      URL={formikProps.values?.PHOTO_URL as string}
                      setField={(photoURL: string) => {
                        formikProps.setFieldValue('PHOTO_URL', getImageUrl(photoURL));
                      }}
                      dest={"STAFF"}
                      id={props?.values?.STAFF_ID}
                    />
                  )}
                </Field>
              </div>
              <div className="grid w-[75%]">
                <Field name="FIRST_NAME">
                  {({ field, form, meta }) => (
                    <Input
                      type="text"
                      label="Staff Name"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Name"
                      name={field.name}
                      onBlur={field.onBlur}
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      required
                      maxLength={50}
                    />
                  )}
                </Field>
                {/* <Field name="MIDDLE_NAME">
                  {({ field, form, meta }) => (
                    <Input
                      name={field.name}
                      onBlur={field.onBlur}
                      type="text"
                      label="Middle Name"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Text"
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                    />
                  )}
                </Field> */}
                <Field name="LAST_NAME">
                  {({ field, form, meta }) => (
                    <Input
                      name={field.name}
                      onBlur={field.onBlur}
                      type="text"
                      label="Staff Surname"
                      value={field.value}
                      onChange={field.onChange}
                      placeholder="Enter Surname"
                      error={meta.touched && meta.error}
                      message={meta.touched && meta.error}
                      maxLength={50}
                    // required
                    />
                  )}
                </Field>
                <Field name="GENDER">
                  {({ field, form, meta }) => (
                    <DropDown
                      label="Gender"
                      options={GENDERS}
                      onChange={item => {
                        form.setFieldValue('GENDER', item.label);
                      }}
                      defaultValue={GENDERS.find(
                        item => item.label === formikProps.initialValues.GENDER,
                      )}
                      name="GENDER"
                      onBlur={field.onBlur}
                      error={
                        formikProps.touched.GENDER && formikProps.errors.GENDER
                      }
                      message={
                        formikProps.touched.GENDER && formikProps.errors.GENDER
                      }
                      required
                    />
                  )}
                </Field>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Field name={`TEACHING_SINCE`} >
                {({ field, form, meta }) => (
                  <Input
                    type="number"
                    label="Teaching Since"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Year"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    required
                  />
                )}
              </Field>
              <Field name={`QUALIFICATION`} >
                {({ field, form, meta }) => (
                  <Input
                    label="Qualification"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Qualification"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    required
                  />
                )}
              </Field>
              <Field name="STAFF_CODE">
                {({ field, form, meta }) => (
                  <Input
                    name={field.name}
                    onBlur={field.onBlur}
                    type="text"
                    label="Staff Code"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Text"
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    // required
                    maxLength={50}
                  />
                )}
              </Field>
              <Field name="LANGUAGE_ID">
                {({ field, form, meta }) => (
                  <DropDown
                    getOptionValue={(option: Language) => option.LANGUAGE_ID}
                    getOptionLabel={(option: Language) =>
                      `${option.NAME.toUpperCase()}`
                    }
                    options={languageList}
                    placeholder="Select Preferred Language"
                    onChange={(item: Language) => {
                      form.setFieldValue('LANGUAGE_ID', item.LANGUAGE_ID);
                    }}
                    label={'Preferred Language'}
                    defaultValue={
                      languageList
                        ? languageList.find(
                          item =>
                            item.LANGUAGE_ID ===
                            form.initialValues.LANGUAGE_ID,
                        )
                        : ''
                    }
                    name="LANGUAGE_ID"
                    onBlur={formikProps.handleBlur}
                    error={
                      formikProps.touched.LANGUAGE_ID &&
                        formikProps.errors.LANGUAGE_ID
                        ? true
                        : false
                    }
                    message={
                      formikProps.touched.LANGUAGE_ID &&
                        formikProps.errors.LANGUAGE_ID
                        ? formikProps.errors.LANGUAGE_ID
                        : ''
                    }
                    required
                  />
                )}
              </Field>

              <Field name="AADHAR_NUMBER">
                {({ field, form, meta }) => (
                  <Input
                    label={renderToggleLabel("Aadhaar Number", "AADHAR_NUMBER") as any}
                    disabled={props.action === 'update' && !enableEdit.AADHAR_NUMBER}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Aadhaar Number"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    maxLength={20}
                  />
                )}
              </Field>
              <MobileComponent
                countryCodeName="COUNTRY_CODE"
                numberName="MOBILE_NUMBER"
                countryList={countryList}
                inputValue={formikProps.values.MOBILE_NUMBER}
                toggleLabel={renderToggleLabel("Mobile Number", "MOBILE_NUMBER") as any}
                disabled={props.action === 'update' && !enableEdit.MOBILE_NUMBER}
                errorCC={formikProps.touched.COUNTRY_CODE && formikProps.errors.COUNTRY_CODE}
                messageCC={formikProps.touched.COUNTRY_CODE && formikProps.errors.COUNTRY_CODE}
                errorMobile={formikProps.touched.MOBILE_NUMBER && formikProps.errors.MOBILE_NUMBER}
                messageMobile={formikProps.touched.MOBILE_NUMBER && formikProps.errors.MOBILE_NUMBER}
              />

              <MobileComponent
                restrictCopyPaste={true}
                countryCodeName="CONFIRM_COUNTRY_CODE"
                numberName="CONFIRM_MOBILE_NUMBER"
                label='Confirm Mobile Number'
                countryList={countryList}
                inputValue={formikProps.values.CONFIRM_MOBILE_NUMBER}
                disabled={props.action === 'update' && !enableEdit.MOBILE_NUMBER}
                errorCC={formikProps.touched.CONFIRM_COUNTRY_CODE && formikProps.errors.CONFIRM_COUNTRY_CODE}
                messageCC={formikProps.touched.CONFIRM_COUNTRY_CODE && formikProps.errors.CONFIRM_COUNTRY_CODE}
                errorMobile={formikProps.touched.CONFIRM_MOBILE_NUMBER && formikProps.errors.CONFIRM_MOBILE_NUMBER}
                messageMobile={formikProps.touched.CONFIRM_MOBILE_NUMBER && formikProps.errors.CONFIRM_MOBILE_NUMBER}
              />

              

              <Field name="EMAIL_ID">
                {({ field, form, meta }) => (
                  <Input
                    type="email"
                    label={renderToggleLabel("Email ID", "EMAIL_ID") as any}
                    disabled={props.action === 'update' && !enableEdit.EMAIL_ID}
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Email ID"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    maxLength={45}
                  />
                )}
              </Field>
               <Field name="PINCODE">
                {({ field, form, meta }) => (
                  <Input
                    type="text"
                    label="Pin Code"
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Enter Pin Code"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    allowOnlyNumbers={true}
                    required
                    maxLength={10}
                  />
                )}
              </Field>
              <Field name="CITY_ID">
                {({ field, form, meta }) => (
                  <DropDown
                    getOptionValue={(option: City) => option.CITY_ID}
                    getOptionLabel={(option: City) =>
                      `${option.NAME.toUpperCase()}`
                    }
                    options={cityList}
                    placeholder="Select City"
                    onChange={(item: City) => {
                      form.setFieldValue('CITY_ID', item.CITY_ID);
                    }}
                    menuPlacement="top"
                    label={'City'}
                    width="my-2 w-full"
                    defaultValue={
                      cityList
                        ? cityList.find(
                          item => item.CITY_ID === form.initialValues.CITY_ID,
                        )
                        : ''
                    }
                    name="CITY_ID"
                    onBlur={field.onBlur}
                    error={
                      formikProps.touched.CITY_ID && formikProps.errors.CITY_ID
                    }
                    message={
                      formikProps.touched.CITY_ID && formikProps.errors.CITY_ID
                    }
                    required
                  />
                )}
              </Field>
              <Field name="BIRTH_DATE">
                {({ field, form, meta }) => (
                  <DateTimePicker
                    minMaxNotRequired={true}
                    formik={true}
                    value={endDate || new Date()}
                    onChange={item => {
                      setendDate(item);
                      form.setFieldValue(
                        'BIRTH_DATE',
                        getCurrentDate(item, true),
                      );
                    }}
                    required={true}
                    isedit={props?.action === 'update'}
                    label={'Birth Date'}
                    placeholder="Enter Birth Date"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    maxDate={dt.addYears(new Date(), 100)}
                    minDate={new Date(1900, 0, 1)}
                  />

                )}
              </Field>
              <Field name="JOINING_DATE">
                {({ field, form, meta }) => (
                  <DateTimePicker
                    minMaxNotRequired={true}
                    formik={true}
                    value={startDate || new Date()}
                    onChange={item => {
                      setstartDate(item);
                      form.setFieldValue(
                        'JOINING_DATE',
                        getCurrentDate(item, true),
                      );
                    }}
                    required={true}
                    isedit={props?.action === 'update'}
                    label={'Joining Date'}
                    placeholder="Enter Joining Date"
                    name={field.name}
                    onBlur={field.onBlur}
                    error={meta.touched && meta.error}
                    message={meta.touched && meta.error}
                    maxDate={dt.addYears(new Date(), 100)}
                    minDate={new Date(1900, 0, 1)}
                  />

                )}
              </Field>
              <Field name="ADDRESS">
                {({ field, form, meta }) => (
                  <TextArea
                    value={field.value}
                    onChange={e =>
                      form.setFieldValue('ADDRESS', e.target.value)
                    }
                    placeholder="Address"
                    label="Address"
                    name="ADDRESS"
                    onBlur={field.onBlur}
                    error={
                      formikProps.touched.ADDRESS && formikProps.errors.ADDRESS
                    }
                    message={
                      formikProps.touched.ADDRESS && formikProps.errors.ADDRESS
                    }
                    required
                    maxLength={200}
                  />
                )}
              </Field>
            </div>
            <div className="grid mt-4 gap-4">
              <Field name="CLASS_TEACHER">
                {({ field, form, meta }) => (
                  <DropDown
                    isMulti
                    getOptionValue={(option: Class) => option.CLASS_ID}
                    getOptionLabel={(option: Class) =>
                      `${option.NAME.toUpperCase()}`
                    }
                    options={classList.filter(
                      __class =>
                        !props?.values?.CLASS_TEACHER.find(
                          __item => __item.Class.CLASS_ID === __class.CLASS_ID,
                        ),
                    )}
                    placeholder="Select Classes Taught"
                    onChange={(classes: Class[]) => {
                      form.setFieldValue('CLASS_TEACHER', classes);
                    }}
                    label={'Classes Taught'}
                    menuPlacement="top"
                    name="CLASS_TEACHER"
                    onBlur={field.onBlur}
                    error={formikProps.errors.CLASS_TEACHER}
                    message={formikProps.errors.CLASS_TEACHER}
                  />
                )}
              </Field>
              {props?.values &&
                props.action === 'update' &&
                props?.values?.CLASS_TEACHER.length > 0 && (
                  <div className="p-2">
                    {props?.values?.CLASS_TEACHER.map(
                      (classTeacher, classTeacherIndex) => (
                        <div className="w-full p-2 flex border-b-[1px] border-b-neutral-40">
                          <PhotoNameCell
                            className="text-lg w-[60%]"
                            NAME={getName([
                              classTeacher?.Class?.NAME,
                              `(${classTeacher?.Class?.CLASS_CODE})`,
                            ])}
                            URL={props?.values?.PHOTO_URL as string}
                          />
                          <div className="ml-auto">
                            <Button
                              button
                              className="ml-auto"
                              type="white"
                              label="DELETE"
                              onClick={() => {
                                setmodalPayload({
                                  CLASS_ID:
                                    classTeacher?.Class?.CLASS_ID ??
                                    classTeacher?.StaffClass?.CLASS_ID,
                                  STAFF_ID: props?.values?.STAFF_ID,
                                });
                                setshowModalClassStaff(true);
                              }}
                            />
                          </div>
                        </div>
                      ),
                    )}
                  </div>
                )}
              <Field name="STAFF_ROLES">
                {({ field, form, meta }) => (
                  <DropDown
                    isMulti
                    getOptionValue={(option: BranchRole) =>
                      option?.BRANCH_ROLE_ID
                    }
                    getOptionLabel={(option: BranchRole) =>
                      `${(option.NAME as string).toUpperCase()}`
                    }
                    options={branchRoleList.filter(
                      branchRole => {
                        const isAlreadySelected = !!props?.values?.STAFF_ROLES.find(
                          __item =>
                            (__item?.BranchRole?.BRANCH_ROLE_ID || __item?.BRANCH_ROLE_ID) ===
                            branchRole?.BRANCH_ROLE_ID,
                        );

                        if (isAlreadySelected) return false;

                        const roleName = (branchRole.NAME as string).toUpperCase();
                        const isRestrictedRole = roleName === 'SUPER ADMIN' || roleName === 'ADMIN' || roleName === 'SUPERADMIN';

                        if (isRestrictedRole) {
                          return checkSuperAdmin(authData);
                        }

                        return true;
                      }
                    )}
                    placeholder="Select Roles"
                    onChange={(roles: BranchRole[]) => {
                      form.setFieldValue('STAFF_ROLES', roles);
                    }}
                    label={'Staff Roles'}
                    name="STAFF_ROLES"
                    onBlur={field.onBlur}
                    error={
                      formikProps.touched.STAFF_ROLES &&
                      formikProps.errors.STAFF_ROLES
                    }
                    message={
                      formikProps.touched.STAFF_ROLES &&
                      formikProps.errors.STAFF_ROLES
                    }
                    required
                  />
                )}
              </Field>
              {props.action === 'update' && (
                <div className="p-2">
                  {props?.values &&
                    props?.values?.STAFF_ROLES.map(
                      staffRole => {
                        const staffRoleId = Number(
                          staffRole?.StaffRole?.STAFF_ROLE_ID || staffRole?.STAFF_ROLE_ID || 0,
                        );
                        const editedStaffId = Number(
                          staffRole?.StaffRole?.STAFF_ID ||
                          staffRole?.STAFF_ID ||
                          props?.values?.STAFF_ID ||
                          0,
                        );
                        const loggedInStaffId = Number(
                          authData?.STAFF_ROLE?.STAFF_ID ||
                          authData?.STAFF_INFO?.[0]?.STAFF_ID ||
                          0,
                        );
                        const isSameStaff =
                          (!!loggedInStaffId && editedStaffId === loggedInStaffId) ||
                          (!!authData?.USER_ID &&
                            Number(props?.values?.USER_ID) === Number(authData.USER_ID));
                        const branchRoleId = Number(
                          staffRole?.BranchRole?.BRANCH_ROLE_ID ||
                          staffRole?.StaffRole?.BRANCH_ROLE_ID ||
                          staffRole?.BRANCH_ROLE_ID ||
                          0,
                        );
                        const activeBranchRoleId = Number(
                          authData?.STAFF_ROLE?.BRANCH_ROLE_ID || 0,
                        );
                        const roleName = String(
                          staffRole?.BranchRole?.NAME ||
                          staffRole?.STAFF_ROLE_NAME ||
                          staffRole?.NAME ||
                          '',
                        ).toUpperCase().replace(/[^A-Z0-9]/g, '');
                        const activeRoleName = String(
                          authData?.STAFF_ROLE?.STAFF_ROLE_NAME || '',
                        ).toUpperCase().replace(/[^A-Z0-9]/g, '');
                        const isSameRole =
                          (!!staffRoleId &&
                            staffRoleId === Number(authData?.STAFF_ROLE?.STAFF_ROLE_ID)) ||
                          (!!branchRoleId &&
                            !!activeBranchRoleId &&
                            branchRoleId === activeBranchRoleId) ||
                          (!!roleName && !!activeRoleName && roleName === activeRoleName);
                        const isCurrentLoggedInRole =
                          isSameStaff && isSameRole;

                        return (
                        <div key={"asdajskdhajdkasd" + (staffRole?.BranchRole?.BRANCH_ROLE_ID || staffRole?.BRANCH_ROLE_ID)} className="w-full p-2 flex border-b-[1px] border-b-neutral-40">
                          <Tag
                            className={`${RoleColors(
                              (staffRole?.BranchRole?.BRANCH_ROLE_ID || staffRole?.BRANCH_ROLE_ID),
                            )} py-2 px-2 text-sm`}
                            label={staffRole?.BranchRole?.NAME || staffRole?.NAME}
                          />
                          <div className="ml-auto flex items-center">
                            {isCurrentLoggedInRole ? (
                              <div className="text-primary-main font-bold mr-4">
                                LOGGED IN
                              </div>
                            ) : (
                              <Button
                                button
                                className="ml-auto"
                                type="white"
                                label="DELETE"
                                onClick={() => {
                                  setmodalPayload({
                                    STAFF_ROLE_ID: staffRoleId,
                                    STAFF_ID: editedStaffId,
                                  });
                                  setshowModal(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                        );
                      },
                    )}
                </div>
              )}
              <div className="grid grid-cols-12">
                <div className="col-span-7"></div>
              </div>
            </div>
            {state?.isLoadinguserData ? <div><SetupLoader height='h-[8vh]' /></div> : <div className='flex justify-center'>
              <Button
                isPreviousYearCheckNotRequied={true}
                submit
                type="primary"
                label={props.action ? 'Update' : 'Submit'}
                width="mb-[2vh] mt-[2vw]"
                disabled={!formikProps.dirty}
              />
            </div>}
          </Form>
        )}
      </Formik>
    </Div>
  ) : (
    <SetupLoader />
  );
});

const Div = styled.div``;
